// src/hooks/useAuth.js
import { useSelector, useDispatch } from 'react-redux';
import { login, logout, register, getProfile, updateProfile } from '../store/authSlice.js';

export const useAuth = () => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, isLoading, error } = useSelector((state) => state.auth);

  const handleLogin = (credentials) => dispatch(login(credentials));
  const handleLogout = () => dispatch(logout());
  const handleRegister = (data) => dispatch(register(data));
  const handleGetProfile = () => dispatch(getProfile());
  const handleUpdateProfile = (data) => dispatch(updateProfile(data));

  return {
    user,
    isAuthenticated,
    isLoading,
    error,
    login: handleLogin,
    logout: handleLogout,
    register: handleRegister,
    getProfile: handleGetProfile,
    updateProfile: handleUpdateProfile,
  };
};